// Wrappers para /api/availability/*.

import { apiFetch } from './api';

export interface FreeSlot {
  date: string;   // YYYY-MM-DD
  start: string;  // HH:MM
  end: string;    // HH:MM
}

export interface FreeSlotsResponse {
  status: 'ok';
  from: string;
  to: string;
  slots: FreeSlot[];
}

export async function getTeacherFreeSlots(teacherId: number, fromIso: string, toIso: string): Promise<FreeSlotsResponse> {
  const q = new URLSearchParams({ from: fromIso, to: toIso });
  return apiFetch<FreeSlotsResponse>(`/availability/teacher/${teacherId}/free?${q.toString()}`);
}

export interface AvailabilityPattern {
  id: number;
  teacher_id: number;
  weekday: number;
  start_time: string;
  end_time: string;
  effective_from: string | null;
  effective_until: string | null;
  active: number;
  created_at: string;
  updated_at: string;
}

export async function listMyPatterns(): Promise<AvailabilityPattern[]> {
  const r = await apiFetch<{ status: 'ok'; items: AvailabilityPattern[] }>(`/availability/me/patterns`);
  return r.items;
}

export async function createPattern(input: { weekday: number; start_time: string; end_time: string }): Promise<{ id: number }> {
  return apiFetch<{ status: 'ok'; id: number }>(`/availability/me/patterns`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function deletePattern(id: number): Promise<void> {
  await apiFetch(`/availability/me/patterns/${id}`, { method: 'DELETE' });
}

export interface AvailabilityException {
  id: number;
  teacher_id: number;
  exception_date: string;
  start_time: string | null;
  end_time: string | null;
  is_available: number;
  reason: string | null;
}

export async function createException(input: {
  exception_date: string;
  start_time?: string | null;
  end_time?: string | null;
  is_available: boolean;
  reason?: string | null;
}): Promise<{ id: number }> {
  return apiFetch<{ status: 'ok'; id: number }>(`/availability/me/exceptions`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function deleteException(id: number): Promise<void> {
  await apiFetch(`/availability/me/exceptions/${id}`, { method: 'DELETE' });
}
